<template>
  <div class="container">
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>

    <!-- 新增按钮区域 -->
    <div class="operation-bar">
      <el-button type="primary" @click="showGenerateTaskDialog">按项目名称生成任务</el-button>
      <!-- <el-button type="danger" :disabled="selectedRows.length === 0" @click="batchDeletePendingTasks">批量删除任务</el-button> -->
    </div>

    <!--列表-->
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#e8f0f9', color: '#3a6ea5' }" style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column border label="序号" prop="id"></el-table-column>
      <el-table-column border label="项目ID" prop="project_id"></el-table-column>
      <el-table-column border label="项目名称" prop="project_name" width="450"></el-table-column>
      <el-table-column border label="任务类型" prop="task_type" width="200"></el-table-column>
      <el-table-column border label="任务状态" prop="task_status"></el-table-column>
      <el-table-column border label="处理时间" prop="handled_time"></el-table-column>
      <el-table-column border label="创建时间" prop="created_time" width="200"></el-table-column>
      <el-table-column border label="下载">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDownload(scope.row)" v-if="scope.row.file_url">{{ scope.row.file_name ||
            '下载文件' }}</el-link>
          <span v-else>{{ scope.row.file_name || '暂无文件' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!-- 添加项目生成任务对话框 -->
    <el-dialog title="按项目名称生成任务" :visible.sync="taskGenerateDialogVisible" width="500px">
      <el-form :model="taskGenerateForm" label-width="120px">
        <el-form-item label="项目名称">
          <el-select v-model="taskGenerateForm.project_name" filterable placeholder="请选择项目名称" style="width: 100%">
            <el-option v-for="item in projectNameOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="taskGenerateForm.task_type" placeholder="请选择任务类型" style="width: 100%">
            <el-option v-for="item in searchConfig[1].list" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="taskGenerateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmGenerateTask" :loading="generateTaskLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      headers: { Authorization: this.$Config.userinfo.token },
      loading: false,
      currentConfig: {},
      tableData: [],
      selectedRows: [],
      pagination: { current_page: 1, total: 1, per_page: 10 },
      query: { project_id: "", task_type: "", task_status: "" },
      searchConfig: [
        { key: "project_id", label: "项目ID", type: "input" },
        {
          key: "task_type", label: "任务类型", type: "select", list: [
            { label: "按隐患导出隐患台账", value: "按隐患导出隐患台账" },
            { label: "按位置导出隐患台账(合并)", value: "按位置导出隐患台账(合并)" },
            { label: "生成报告", value: "生成报告" },
            { label: "生成告知书", value: "生成告知书" },
            { label: "生成告知书(有图)", value: "生成告知书(有图)" },
            { label: "生成复检报告", value: "生成复检报告" }
          ]
        },
        {
          key: "task_status", label: "任务状态", type: "select", list: [
            { label: "处理中", value: "处理中" },
            { label: "已完成", value: "已完成" }
          ]
        }
      ],
      // 新增项目生成任务相关数据
      taskGenerateDialogVisible: false,
      taskGenerateForm: {
        project_name: '',
        task_type: ''
      },
      projectNameOptions: [],
      generateTaskLoading: false
    }
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
    // 显示生成任务对话框
    async showGenerateTaskDialog() {
      this.taskGenerateDialogVisible = true;
      this.taskGenerateForm = {
        project_name: '',
        task_type: ''
      };
      // 获取项目名称列表
      await this.getProjectNames();
    },
    // 获取项目名称列表
    async getProjectNames() {
      try {
        const response = await this.$Api.get("get_project_names");
        this.projectNameOptions = response.map(item => ({
          label: item.label,
          value: item.value
        }));
      } catch (e) {
        this.$message.error(e.errormsg || '获取项目列表失败');
      }
    },
    // 确认生成任务
    async confirmGenerateTask() {
      if (!this.taskGenerateForm.project_name) {
        return this.$message.warning('请选择项目名称');
      }
      if (!this.taskGenerateForm.task_type) {
        return this.$message.warning('请选择任务类型');
      }

      try {
        this.generateTaskLoading = true;
        await this.$Api.post("generate_tasks_by_project_name", this.taskGenerateForm);
        this.$message.success('任务生成成功');
        this.taskGenerateDialogVisible = false;
        // 刷新任务列表
        this.getList();
      } catch (e) {
        this.$message.error(e.errormsg || '生成任务失败');
      } finally {
        this.generateTaskLoading = false;
      }
    },

    // 新增处理表格选择变化的方法
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    // 新增按项目名称生成任务方法
    generateTaskByProject() {
      this.showGenerateTaskDialog();
    },

    // 新增批量删除处理中的任务方法
    batchDeletePendingTasks() {
      const pendingTasks = this.selectedRows.filter(row => row.task_status === '处理中');

      if (pendingTasks.length === 0) {
        return this.$message.warning('没有选中处于处理中状态的任务');
      }

      this.$confirm(`确定删除选中的 ${pendingTasks.length} 个处理中的任务?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          this.loading = true;
          // TODO: 调用后端API批量删除任务
          // const taskIds = pendingTasks.map(task => task.id);
          // await this.$Api.post("delete_tasks", { task_ids: taskIds });

          this.$message.success('删除成功');
          this.getList();
        } catch (e) {
          this.$message.error(e.errormsg || '删除失败');
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        this.$message.info('已取消删除操作');
      });
    },

    async handleDownload(row) {
      try {
        if (row.file_url) {
          window.open(row.file_url);
        } else {
          this.$message.error("文件 URL 不存在");
        }
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        project_id: "",
        task_type: "",
        task_status: ""
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.post("task_list", params);
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style scoped>
.small-upload {
  width: 50px;
  height: 50px;
}

.operation-bar {
  margin: 15px 0;
  display: flex;
  gap: 10px;
}
</style>